import { ActivitiesEnum } from './../../../services/api-names';
import {
  HttpBackend,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { Inject, Injectable, NgZone } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { map } from 'rxjs/operators';
import { Serializer } from '../../../helpers/serializer/seriealizer';
import { Utils } from '../../../utils/utils';

import { GetActivitiesResponseInterface } from '../response/interfaces/getactivities-response.interface';
import { GetActivitiesResponseModel } from '../response/models/getactivities-response.model';
import { OrdersResponseInterface } from '../response/interfaces/orders-response.interface';
import { OrdersResponseModel } from '../response/models/orders-response.model';
import { TECH_LIB_PORTAL_CONFIG, TechLibPortalConfig } from '../../../tech-lib-portal.interceptor';
import { SessionService } from './../../../services/session.service';
import { GenericMessageResponseInterface } from '../response/interfaces/generic-message.interface';
import { GenericMessageResponseModel } from '../response/models/generic-message.model';

@Injectable({
  providedIn: 'root',
})

export class ActivitiesService {
  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig,
    private httpBackend: HttpBackend,
    private httpClient: HttpClient,
    private serializer: Serializer,
    private session: SessionService,
    private zone: NgZone
  ) { }

  private updateSession() {
    this.config.sessionToken = this.session.sessionToken;
    this.config.domain = this.session.domain;
    this.config.clientCode = this.session.clientCode;
    this.config.language = this.session.language;
  }

  public getActivities(portfoliocode: string,
    initialdate: string, enddate: string): Observable<GetActivitiesResponseInterface> {

    const url = Utils.formatString(
      this.config.baseApi + ActivitiesEnum.api_portal_get_activities,
      [portfoliocode, initialdate, enddate]
    );

    this.updateSession();

    return new Observable(
      (observer: Observer<GetActivitiesResponseModel>) => {
        this.httpClient
          .get<GetActivitiesResponseInterface>(url)
          .pipe(
            map((resp: any) => {
              return resp as GetActivitiesResponseModel;
            })
          )
          .subscribe(
            (resp: any) => {
              observer.next(resp);
              observer.complete();
            },
            (err) => observer.error(err)
          );
      }
    );
  }

  public getActivitiesOrder(portfoliocode: string,
    activityid: string): Observable<OrdersResponseInterface[]> {

    const url = Utils.formatString(
      this.config.baseApi + ActivitiesEnum.api_portal_get_activities_orders, [portfoliocode, activityid]);

    this.updateSession();

    return new Observable(
      (observer: Observer<OrdersResponseModel[]>) => {
        this.httpClient
          .get<OrdersResponseInterface[]>(url)
          .pipe(
            map((resp: any) => {
              return resp as OrdersResponseModel[];
            })
          )
          .subscribe(
            (resp: any) => {
              observer.next(resp);
              observer.complete();
            },
            (err) => observer.error(err)
          );
      }
    );
  }

  public activitiesContribution(portfolioCode: string, activityId: string): Observable<GenericMessageResponseInterface> {
    const url =
      this.config.baseApi +
      Utils.formatString(ActivitiesEnum.api_activities_contribution_delete, [portfolioCode, activityId]);

    this.updateSession();

    return new Observable(
      (observer: Observer<GenericMessageResponseInterface>) => {
        this.httpClient
          .delete(url)
          .pipe(
            map((resp: any) => {
              const t = this.serializer.fromJson(
                resp,
                GenericMessageResponseModel
              );
              return t;
            })
          )
          .subscribe(
            (resp: any) => {
              observer.next(resp);
              observer.complete();
            },
            (err) => observer.error(err)
          );
      }
    );
  }

  public activitiesWithdrawal(portfolioCode: string, activityId: string): Observable<GenericMessageResponseInterface> {
    const url =
      this.config.baseApi +
      Utils.formatString(ActivitiesEnum.api_activities_withdrawal_delete, [portfolioCode, activityId]);

    this.updateSession();

    return new Observable(
      (observer: Observer<GenericMessageResponseInterface>) => {
        this.httpClient
          .delete(url)
          .pipe(
            map((resp: any) => {
              const t = this.serializer.fromJson(
                resp,
                GenericMessageResponseModel
              );
              return t;
            })
          )
          .subscribe(
            (resp: any) => {
              observer.next(resp);
              observer.complete();
            },
            (err) => observer.error(err)
          );
      }
    );
  }





}
